import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

const UploadPasteBlock = ({ onFileDrop }) => {
  // Use Dropzone hook for the visible dropzone component
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onFileDrop,
    accept: {
      "text/csv": [".csv"],
      "application/json": [".json"],
    },
    multiple: false, // Only accept one file at a time
    noKeyboard: true, // Disable keyboard navigation for this dropzone
  });

  // const handlePaste = (e) => {
  //   const pastedData = e.clipboardData.getData("text");
  //   if (onPaste) {
  //     onPaste(pastedData);
  //   }
  //   console.log("Data pasted:", pastedData);
  // };

  return (
    <div >

      <div className="upload-paste-row">
        {/* File Drop Zone */}
        <div {...getRootProps()} className={`file-dropzone ${isDragActive ? "drag-active" : ""}`}>
          <input {...getInputProps()} />
          <div className="dropzone-content">
            <div className="upload-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15V3M12 3L8 7M12 3L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M2 17L2 18C2 19.1046 2.89543 20 4 20L20 20C21.1046 20 22 19.1046 22 18L22 17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="dropzone-text">
              <div className="primary-text">Drop a file to start</div>
              <div className="secondary-text">(CSV & JSON)</div>
            </div>
          </div>
        </div>

        {/* Paste Data Area
        <div className="paste-area">
          <textarea
            placeholder="Paste cells here to start building a view"
            className="paste-textarea"
            rows={8}
            onPaste={handlePaste}
            disabled={isProcessingFile}
          />
        </div> */}
      </div>
    </div>
  );
};

UploadPasteBlock.propTypes = {
  onFileDrop: PropTypes.func.isRequired,
  // onPaste: PropTypes.func,
  // isProcessingFile: PropTypes.bool,
};

export default UploadPasteBlock;
